import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

import { getFormattedAdPrice } from 'SRC/utils'

const renderPriceRange = (priceFrom, priceTo, t) => {
  console.log('priceFrom, priceTo', priceFrom, priceTo)

  if (priceFrom && priceTo) {
    return <div className='cena' key='priceRange'>
      <p>{getFormattedAdPrice(priceFrom)} {t('do')} {getFormattedAdPrice(priceTo)} &euro;</p>
    </div>
  } else if (priceFrom && !priceTo) {
    return <div className='cena' key='priceFrom'>
      <p>{t('Već od')} {getFormattedAdPrice(priceFrom)} &euro;</p>
    </div>
  } else if (!priceFrom && priceTo) {
    return <div className='cena' key='priceTo'>
      <p>{t('Do')} {getFormattedAdPrice(priceTo)} &euro;</p>
    </div>
  } else {
    return null
  }
}

const renderRetailPrice = (price, discount) => {
  return <React.Fragment>
    <div className='cena'>
      <p>{getFormattedAdPrice(price)} &euro;</p>
    </div>
    &nbsp;
    {
      discount ? <div className='cena-akcija'>
        <p>{getFormattedAdPrice(discount)} &euro;</p>
      </div> : null
    }
  </React.Fragment>
}

const renderTypeOfPrice = (price, typeOfPrice) => {
  if (price) {
    return (
      <div>
        <div className='cena' key='price'>
          <p>{typeOfPrice.format.replace('{price}', price)}</p>
        </div>
      </div>
    )
  }

  return null
}

export const Price = ({ price, discount, priceType, priceFrom, priceTo, priceOnRequest, typeOfPrice }) => {
  const { t } = useTranslation('common')

  if (typeOfPrice) return renderTypeOfPrice(price, typeOfPrice)

  return (
    <div>
      {!priceOnRequest
        ? priceFrom || priceTo
          ? renderPriceRange(priceFrom, priceTo, t)
          : renderRetailPrice(price, discount)
        : <div className='cena'>
          <p>{t('Cijena na upit')}</p>
        </div>
      }
      &nbsp;
      {
        priceType && !priceOnRequest
          ? <div className='vrsta-cene'>
            <p>{t(priceType)}</p>
          </div>
          : null
      }
    </div>
  )
}

Price.propTypes = {
  discount: PropTypes.number,
  price: PropTypes.number.isRequired,
  priceFrom: PropTypes.number,
  priceTo: PropTypes.number,
  priceType: PropTypes.string,
  priceOnRequest: PropTypes.bool,
  typeOfPrice: PropTypes.object
}
